import {getManyDraws} from "@/modules/perRoad/lib/simulation/monteCarloDraw";
import {perRoadStore} from "@/store/store";
import {
  getHorizontalStrainValuesFromWesleaResults,
  getPercentileAtValue
} from "@/modules/perRoad/lib/calculations/horizontalStrainDistribution";
import {IPrMonteCarloDrawImperial, IWesleaConfig, IWesleaResult} from "@/modules/perRoad/interfaces/monteCarlo";
import {IPerRoadScenarioImperial, LayerPerformanceCriteriaLocation} from "@/modules/perRoad/interfaces/perRoad";
import {DistributionTypes} from "@/lib/monteCarlo/interfaces";


export const getCurrentError = (
  resultTable: {
    uStrain: number,
    targetPct: number,
    actualPct: number,
    isSuccess: boolean
  }[]) => {

  return resultTable.map(r => r.actualPct - r.targetPct).reduce((a, b) => a + b, 0);
};


export const simulateAndGetTotalError = async function (numRuns: number, scenarioImperial: IPerRoadScenarioImperial, distributionPercentiles: number[], distribution_ustrain: number[], setNumberOfCompletedRunsCallback: Function | null = null): Promise<number> {
  /**
   * Run a set of simulations and calculate the total error. Discard results, return only error.
   */

  const drawsMap: { [index: string]: IPrMonteCarloDrawImperial } = {};

  // const startTime = performance.now();
  const simScenarios = getManyDraws(numRuns, scenarioImperial);

  simScenarios.draws.forEach(draw => {
    drawsMap[draw.id] = draw;
  });

  let completedDraws = 0;

  // Object.entries(simScenarios.wesleaConfigs).forEach(async (kv) => {
  return await Promise.all(Object.entries(simScenarios.wesleaConfigs).map(async (kv) => {
    // console.log(kv[0]);
    const drawId = kv[0];
    const wesConfig = kv[1];

    const packagedConfig: { [index: string]: IWesleaConfig } = {};
    packagedConfig[drawId] = wesConfig;

    const resultBatch = await perRoadStore.runManySimulations(packagedConfig);//.then((resultBatch: IWesleaResultBatch)
                                                                              // => {
    const id = Object.keys(resultBatch)[0];
    const result = <IWesleaResult[]>Object.values(resultBatch)[0];
    completedDraws += 1;

    // Report the number of runs that are done so the user isn't left wondering what the heck is going on
    if (setNumberOfCompletedRunsCallback !== null) {
      setNumberOfCompletedRunsCallback(completedDraws);
    }

    // console.log(completedDraws, id);
    if (id){
      drawsMap[id].wesleaResult = result;
    }
    //
    //
    //   }).catch(error => {
    //     // The run failed, we don't expect a result
    //     console.error(error);
    //     expectedResults -= 1;
    //   });
  })).then(() => {
      // console.log("Computing results");
      const strains = getHorizontalStrainValuesFromWesleaResults(Object.values(drawsMap), 1, LayerPerformanceCriteriaLocation.BOTTOM);
      const resultTable = getResultTable(distributionPercentiles, distribution_ustrain, strains);
      const strainError = getCurrentError(resultTable);
      // console.log(`Strain error: ${strainError}`);
      return strainError;
    }
  );
};

export const percentileAtTargetStrain = (
  distributionPercentiles: number[],
  distribution_ustrain: number[],
  horizontalStrainValues: number[]
) => {
  let actualPercentiles: number[] = [];

  if (distribution_ustrain && distributionPercentiles) {
    actualPercentiles = getPercentileAtValue(
      horizontalStrainValues,
      distribution_ustrain,
      distributionPercentiles,
    );
  }

  return actualPercentiles;
};

export const getResultTable = (
  distributionPercentiles: number[],
  distribution_ustrain: number[],
  horizontalStrainValues: number[]
) => {


  const percentiles = percentileAtTargetStrain(distributionPercentiles, distribution_ustrain, horizontalStrainValues);

  if (distributionPercentiles && distribution_ustrain) {
    return distributionPercentiles.map((pct, i) => ({
      uStrain: distribution_ustrain[i],
      targetPct: pct,
      actualPct: percentiles[i] * 100,
      isSuccess: pct < percentiles[i] * 100,
    }));
  }

  return [];
};


export const meanThicknessOfTopLayer = (s: IPerRoadScenarioImperial): number => {
  if (s.layers[0].thickness_in.prob !== DistributionTypes.normal) {
    throw("Distribution must be normal!");
  }

  // @ts-ignore
  return s.layers[0].thickness_in.mean;
};


export const setTopLayerThicknessAndMakeACopy = (thickness_in: number, s: IPerRoadScenarioImperial): IPerRoadScenarioImperial => {
  const s2: IPerRoadScenarioImperial = JSON.parse(JSON.stringify(s));
  if (s.layers[0].thickness_in.mean !== null) {
    s2.layers[0].thickness_in.mean = thickness_in;
  } else {
    throw("No mean value found for thickness distribution.");
  }

  return s2;
};
